<script lang="ts">
  import CaretDown from "~icons/ph/caret-down";
  import { localizeDate } from "../lib/date";

  let {
    label,
    documents,
    displayMatterLabel = false,
    class: className = "",
  }: {
    label: string;
    documents: {name: string, type: string, created_at: string, matter_label: string | null}[];
    displayMatterLabel: boolean;
    class?: string;
  } = $props();
</script>

<div class={className}>
  <details class="group">
    <summary class="cursor-pointer list-none [&::-webkit-details-marker]:hidden">
      <div class="font-semibold flex items-center gap-2">
        <CaretDown class="group-open:rotate-180 w-4 h-4 inline-block transition-transform"/>
        <span>{label}</span>
        <span class="badge badge-secondary h-6 {documents.length < 10 ? "w-6" : ""}">{documents.length}</span>
      </div>
    </summary>
    <div>
      {#each documents as document}
        <div class="py-2 sm:py-4 last:pb-0 border-t first:mt-2 lg:first:mt-4 text-sm lg:text-base">
          <div class="flex justify-between flex-wrap">
            <span class="break-all">{document.name}</span>
            <span class="text-right flex-grow">{localizeDate(document.created_at, {month: "short", year: "2-digit"})}</span>
          </div>
          <div class="text-gray-600">
            {#if displayMatterLabel}
              <span>{document.matter_label}</span>
              {#if document.type}<span> - </span>{/if}
            {/if}
            <span>{document.type}</span>
          </div>
        </div>
      {/each}
    </div>
  </details>
</div>
